<template>
  <div>
    <div class="form-group row">
        <div class="col-md-6">
          <label for="txtMachineWorkshop"><small class="text-danger">*</small> {{$lang.Sinister.Details.MachineWorkshop}}:</label>
          <div class="input-group">
            <span class="input-group-addon custom-group-addon" @click="showModal"><i class="fa fa-plus-circle"></i></span>
            <autocomplete ref="machineWorkshopTypeahead"
                              v-model="machineWorkshopSearch"
                              :placeholder="$lang.Sinister.Details.PlaceholderMachineWorkshop"
                              :serializer="s => s.text"
                              :data="listMachineWorkshop"
                              @hit="selecteMachineWorkshop = $event"
                              inputClass="autocompleteClass"
                              style="width: 100%;padding-left: 40px;"
                              />
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtContactMachineWorkshop">{{$lang.Sinister.Details.ContactMachineWorkshop}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          v-model="form.contact.value"
                          :maxlength="form.contact.maxlength"
                          :required="form.contact.required"
                          :state="form.contact.state"
                          :placeholder="$lang.Sinister.Details.PlaceholderContactMachineWorkshop"
                          :disabled="true"
                          />
          </div>
        </div>
      </div>
      <Tables v-show="showTable" ref="tableGrid" :showClose="true" v-on:Closed="onClosedTable" :messageTipFooter="$lang.Common.ClickToSelect"
        :columns="[$lang.MechanicalWorkshop.DataTable.Name,
                    $lang.MechanicalWorkshop.DataTable.Phone,
                    $lang.Sinister.Details.ContactMachineWorkshop,
                    'Cidade']">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" classCss="text-left" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.phoneNumber + ' ' + obj.cellNumber" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.city.name  + ' - ' + obj.state.abbreviature" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
          </tr>
      </Tables>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtPhoneNumber">{{$lang.Sinister.Details.Phone}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-phone"></i></span>
            <b-form-input type="text"
                          v-model="form.phoneNumber.value"
                          :maxlength="form.phoneNumber.maxlength"
                          :required="form.phoneNumber.required"
                          :state="form.phoneNumber.state"
                          :placeholder="'(00) 0000-0000'"
                          :mask="['(##) ####-####']"
                          :disabled="true"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCellNumber">{{$lang.Sinister.Details.CellPhone}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-mobile-phone"></i></span>
            <b-form-input type="text"
                          v-model="form.cellNumber.value"
                          :maxlength="form.cellNumber.maxlength"
                          :required="form.cellNumber.required"
                          :state="form.cellNumber.state"
                          :placeholder="'(00) 0 0000-0000'"
                          :mask="['(##) ####-####']"
                          :disabled="true"/>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtContactMachineWorkshop">{{$lang.Sinister.Details.EmailMachineWorkshop}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
            <b-form-input type="text"
                          v-model="form.email.value"
                          :maxlength="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"
                          :placeholder="$lang.Sinister.Details.PlaceholderEmailMachineWorkshop"
                          :disabled="true"
                          />
          </div>
        </div>
      </div>

      <MechanicalWorkshopModal :mechanicalworkshop="objProp" @Edit="onEditById"/>
  </div>
</template>
<script>
import SinisterMechanicalWorkshop from './sinistermechanicalworkshop.js'

export default SinisterMechanicalWorkshop
</script>
<style lang="scss" scoped>
.modal-footer {
  background-color: #eceff1;
  border-bottom: 1px solid #cfd8dc;
}
.custom-group-addon {
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
}
.autocompleteClass {
  padding-left: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/regulation/auto/mechanicalworkshop/sinistermechanicalworkshop.vue